import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

type StatusErrorStripProps = {
  message: string
}

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.25, 2),
    background: theme.palette.background.default,
  },
  text: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
}))

const StatusErrorStrip = ({ message }: StatusErrorStripProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant="body2" className={classes.text}>
        {message}
      </Typography>
    </div>
  )
}

export default StatusErrorStrip
